export default {
  methods: {
    /**
    * 西暦を和暦に変換させる。
    * @param date : 日付 'yyyy-mm-dd'
    */
    toWareki: function (data) {
      // 年月日に切り出して日付データを作成する。
      let year = data.substr(0, 4)
      let month = data.substr(5, 2)
      let date = data.substr(8, 2)
      const dt = new Date(year, (month - 1), date)

      // 和暦に変換させる（yy/mm/dd）
      let wYear = Number(year) - 1988
      wYear = wYear + ''
      if (Number(wYear) < 10) {
        wYear = '0' + wYear
      }
      let wareki = wYear + '/' + month + '/' + date

      let gengo = '平成'

      // 2019年5月～2021年4月は平成扱いにする。
      if (year === '2019' && Number(month) >= 5) {
        wareki = wareki.slice(2)
        wareki = '31' + wareki
        gengo = '平成'
      } else if (year === '2020') {
        wareki = wareki.slice(2)
        wareki = '32' + wareki
        gengo = '平成'
      } else if (year === '2021' && Number(month) <= 4) {
        wareki = wareki.slice(2)
        wareki = '33' + wareki
        gengo = '平成'
      }

      // 令和3年5月から令和扱いにする。
      const reiwa = new Date(2021, (5 - 1), 1)
      const reiwaflg = dt >= reiwa
      if (reiwaflg) {
        const num = wareki.indexOf('/')
        let warekiyear = wareki.substr(0, num) - 30
        // 一桁だった場合、0埋めの処理をする。
        if (String(warekiyear).length === 1) {
          warekiyear = ('0' + warekiyear).slice(-2)
        }
        wareki = warekiyear + wareki.slice(num)
        gengo = '令和'
      }
      // 元号に紐づく値を取得する。
      let gengonumber = ''
      if (gengo === '明治') {
        gengonumber = 0
      } else if (gengo === '大正') {
        gengonumber = 1
      } else if (gengo === '昭和') {
        gengonumber = 2
      } else if (gengo === '平成') {
        gengonumber = 3
      } else if (gengo === '令和') {
        gengonumber = 4
      }
      // データを返却するようにまとめる。
      const warekidata = {}
      year = wareki.substr(0, 2)
      month = wareki.substr(3, 2)
      date = wareki.substr(6, 2)
      warekidata.year = Number(year) // 和暦年 数値型
      warekidata.yearStr = year // 和暦年 文字列
      warekidata.month = Number(month) // 月 数値型
      warekidata.monthStr = month // 月 文字列型
      warekidata.date = Number(date) // 日 数値型
      warekidata.dayStr = date // 日 文字列型
      warekidata.gengo = gengo // 元号
      warekidata.gengonumber = Number(gengonumber) // 元号インデックス(WarekiInputで使用)
      warekidata.wareki = wareki
      return warekidata
    },
    /**
    * 西暦を和暦に変換させる。
    * @param date : 日付 'yyyy-mm-dd'
    */
    toWarekiFromH: function (data) {
      // 年月日に切り出して日付データを作成する。
      let year = data.substr(0, 4)
      let month = data.substr(5, 2)
      let date = data.substr(8, 2)
      const dt = new Date(year, (month - 1), date)

      // 和暦に変換させる（yy/mm/dd）
      let wYear = Number(year) - 1988
      wYear = wYear + ''
      if (Number(wYear) < 10) {
        wYear = '0' + wYear
      }
      let wareki = wYear + '/' + month + '/' + date

      let gengo = '平成'

      // 2019年5月～2021年4月は平成扱いにする。
      if (year === '2019' && month >= '05') {
        wareki = wareki.slice(2)
        wareki = '31' + wareki
        gengo = '平成'
      } else if (year === '2020') {
        wareki = wareki.slice(2)
        wareki = '32' + wareki
        gengo = '平成'
      } else if (year === '2021' && month <= '04') {
        wareki = wareki.slice(2)
        wareki = '33' + wareki
        gengo = '平成'
      }
      // 令和3年5月から令和扱いにする。
      const reiwa = new Date(2021, (5 - 1), 1)
      const reiwaflg = dt >= reiwa
      if (reiwaflg) {
        const num = wareki.indexOf('/')
        let warekiyear = wareki.substr(0, num) - 30
        // 一桁だった場合、0埋めの処理をする。
        if (String(warekiyear).length === 1) {
          warekiyear = ('0' + warekiyear).slice(-2)
        }
        wareki = warekiyear + wareki.slice(num)
        gengo = '令和'
      }
      // 元号に紐づく値を取得する。
      let gengonumber = ''
      if (gengo === '平成') {
        gengonumber = 0
      } else if (gengo === '令和') {
        gengonumber = 1
      }
      // データを返却するようにまとめる。
      const warekidata = {}
      year = wareki.substr(0, 2)
      month = wareki.substr(3, 2)
      date = wareki.substr(6, 2)
      warekidata.year = Number(year) // 和暦年 数値型
      warekidata.yearStr = year // 和暦年 文字列
      warekidata.month = Number(month) // 月 数値型
      warekidata.monthStr = month // 月 文字列型
      warekidata.date = Number(date) // 日 数値型
      warekidata.dayStr = date // 日 文字列型
      warekidata.gengo = gengo // 元号
      warekidata.gengonumber = Number(gengonumber) // 元号インデックス(WarekiInputで使用)
      return warekidata
    },
    /**
    * 和暦を西暦に変換させる。
    * @param date : 年号+年 '平成02'
    */
    toSeireki: function (warekiStr) {
      // 年月日に切り出して日付データを作成する。
      const gengo = warekiStr.substr(0, 2)
      let year = warekiStr.substr(2)

      if (year === '元') {
        year = 1
      }

      // 元号に紐づく値を取得する。
      let yearCalcValue = null
      if (gengo === '明治') {
        yearCalcValue = 1867
      } else if (gengo === '大正') {
        yearCalcValue = 1911
      } else if (gengo === '昭和') {
        yearCalcValue = 1925
      } else if (gengo === '平成') {
        yearCalcValue = 1988
      } else if (gengo === '令和') {
        yearCalcValue = 2018
      }

      const seireki = Number(yearCalcValue) + Number(year)

      return seireki
    },
    /**
     * 年月文字列をDate型にParseします.
     * @param date : 日付 'yyyy-mm'
     */
    dateParseYearMonth (date) {
      const year = Number(date.substr(0, 4))
      const month = Number(date.substr(5, 2)) - 1
      return new Date(year, month)
    },
    /**
    * 現在の消費税を算出する。
    */
    taxRate: function () {
      // var now = new Date()
      // var fiveStart = new Date(1997, 4, 1)
      // var eightStart = new Date(2014, 4, 1)
      // // CMS/POSが9/30の23:55に切り替わるのでCMS/POSに合わせる
      // var tenStart = new Date(2019, 9, 30, 23, 55)
      // if (now.getTime() < fiveStart.getTime()) {
      //   return 0.03
      // } else if (now.getTime() >= fiveStart.getTime() && now.getTime() < eightStart.getTime()) {
      //   return 0.05
      // } else if (now.getTime() >= eightStart.getTime() && now.getTime() < tenStart.getTime()) {
      //   return 0.08
      // } else if (now.getTime() >= tenStart.getTime()) {
      //   return 0.1
      // }
      return 0.1
    },
    /**
     * 整数の場合trueを返します.
     * @param {*} x :判定オブジェクト
     */
    isInteger: function (value) {
      return String(value).match(/^([1-9]\d*|0)$/)
    },
    appHomeBack: function () {
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.homeBack()
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.homeBack.postMessage('')
      }
    },
    /**
     * イベントトラッキング：ページビュー(PVset)
     * @param {string} screenName スクリーン名
     */
    nativePVset: function (screenName) {
      // console.log('@@@@@@@ nativePVset start')
      // console.log(screenName)
      const json = JSON.stringify({ SHOWPAGE: screenName })
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.PVSet(json)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.PVSet.postMessage(json)
      }
      // console.log(json)
      // console.log('@@@@@@@ nativePVset end')
    },
    /**
     * イベントトラッキング：イベント送信(EVENTSet)
     * @param {string} eventName イベント名（パラメータ名）
     * @param {string} buttonName ボタン名
     * @param {string} actionName アクション名（Value）
     * @param {string} customParameters カスタム パラメータ（array）
     */
    nativeEVENTSet: function (eventName, buttonName, actionName, customParameters) {
      // console.log('@@@@@@@ nativeEVENTSet start')
      // console.log(eventName)
      // console.log(buttonName)
      // console.log(actionName)
      /** ネイティブへ渡す形式
      {
        "EVENTNAME": "PushSettinsButton",  //イベント名
        "PUSH_ON": "TAP"  //ボタン名：アクション名
      }
      */
      // キーに変数の値を使うため、ブラケット表記でjsonを設定
      let json = ''
      const baseJson = {
        EVENTNAME: eventName
      }
      baseJson[buttonName] = actionName
      if (customParameters) {
        for (const key in customParameters) {
          baseJson[key] = customParameters[key]
        }
      }
      json = JSON.stringify(baseJson)
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.EVENTSet(json)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.EVENTSet.postMessage(json)
      }
      // console.log(json)
      // console.log('@@@@@@@ nativeEVENTSet end')
    },
    /**
     * 戻るボタン出し分けのfunction
     * @param {boolean}
     */
    appDisplayBack: function (bool) {
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.displayBack(bool)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.displayBack.postMessage(bool)
      }
    },
    /**
     * タイトルの設定
     * @param {string} title タイトル
     */
    appDisplayTitle: function (title) {
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.setTitle(title)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.setTitle.postMessage(title)
      }
    },
    /**
     * 端末の電話を起動します.
     * phoneNumberをプリセットします.
     * @param {*} phoneNumber
     */
    telCalling: function (phoneNumber = '') {
      window.location.href = 'tel:' + phoneNumber
    },
    /**
     * 半角変換（全角英数文字の場合、0xFEE0減算して半角へ）
     */
    toHanKaku: function (str) {
      return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
      })
    },
    /**
     * ナンバープレート以下に分割します.
     * 1.陸運支局(全角)
     * 2.分類番号(半角)
     * 3.平仮名(全角)
     * 4.車両番号(半角)
     * @param {*} plateNumber
     */
    dividePlateNumber: function (plateNumber) {
      const res = {}
      res.plate_number1 = plateNumber.substr(0, 4).trim()
      res.plate_number2 = this.toHanKaku(plateNumber.substr(4, 3).trim())
      res.plate_number3 = plateNumber.substr(7, 1).trim()
      res.plate_number4 = this.toHanKaku(plateNumber.substr(8, 4).trim())
      return res
    },
    /**
     * 車検証API(GET)で取得できない以下の項目をQRデータ（文字列）から整形します.
     * 1.型式                :model
     * 2.陸運支局(空白は削除):plate_number1
     * 3.分類番号(空白は削除):plate_number2
     * 4.平仮名(空白は削除)  :plate_number3
     * 5.車両番号(空白は削除):plate_number4
     * 6.前前軸重(kg)        :axle_load_front_front_weight
     * 7.前後軸重(kg)        :axle_load_front_back_weight
     * 8.後前軸重(kg)        :axle_load_back_front_weight
     * 9.後後軸重(kg)        :axle_load_back_back_weight
     * @param {*} qrRow
     * @param {*} modelCode
     */
    qrFormat: function (qrRow, modelCode) {
      const qrRowSplit = qrRow.split('/')
      const res = {}
      if (modelCode !== 3) {
        // 普通、小型

        // 型式
        res.model = qrRowSplit[5]

        // 軸重は10分の1の値なので10倍してkg単位に変換する
        const frontFrontWeight = Number(qrRowSplit[6]) * 10
        const frontBackWeight = Number(qrRowSplit[7]) * 10
        const backFrontWeight = Number(qrRowSplit[8]) * 10
        const backBackWeight = Number(qrRowSplit[9]) * 10
        res.axle_load_front_front_weight = isNaN(frontFrontWeight) ? 0 : frontFrontWeight
        res.axle_load_front_back_weight = isNaN(frontBackWeight) ? 0 : frontBackWeight
        res.axle_load_back_front_weight = isNaN(backFrontWeight) ? 0 : backFrontWeight
        res.axle_load_back_back_weight = isNaN(backBackWeight) ? 0 : backBackWeight

        const plateNumber = qrRowSplit[20]
        const plateNumbers = this.dividePlateNumber(plateNumber)
        res.plate_number1 = plateNumbers.plate_number1
        res.plate_number2 = plateNumbers.plate_number2
        res.plate_number3 = plateNumbers.plate_number3
        res.plate_number4 = plateNumbers.plate_number4
      } else {
        // 軽

        // 型式
        res.model = qrRowSplit[14]

        // 軸重は10分の1の値なので10倍してkg単位に変換する
        const frontFrontWeight = Number(qrRowSplit[15]) * 10
        const frontBackWeight = Number(qrRowSplit[16]) * 10
        const backFrontWeight = Number(qrRowSplit[17]) * 10
        const backBackWeight = Number(qrRowSplit[18]) * 10
        res.axle_load_front_front_weight = isNaN(frontFrontWeight) ? 0 : frontFrontWeight
        res.axle_load_front_back_weight = isNaN(frontBackWeight) ? 0 : frontBackWeight
        res.axle_load_back_front_weight = isNaN(backFrontWeight) ? 0 : backFrontWeight
        res.axle_load_back_back_weight = isNaN(backBackWeight) ? 0 : backBackWeight

        const plateNumber = qrRowSplit[3]
        const plateNumbers = this.dividePlateNumber(plateNumber)
        res.plate_number1 = plateNumbers.plate_number1
        res.plate_number2 = plateNumbers.plate_number2
        res.plate_number3 = plateNumbers.plate_number3
        res.plate_number4 = plateNumbers.plate_number4
      }
      return res
    },
    /**
     * ネイティブから取得したクエリパラメータを元に
     * apifunc関連のAPI呼び出し時のリクエストヘッダを作成します.
     * ヘッダのvalueは以下.
     * {アプリバージョン}/{プラットフォーム}/{OSバージョン}
     *
     * versionData配下の変数はappVersion,platform,osVersionとする.
     *
     * appVersion,platform,osVersionが未定義の場合はデフォルト値として以下を使用.
     * appVersion : '0.0.0'
     * platform   : 'iRidge'
     * osVersion  : '0.0'
     * ref.https://gitlab.ssl.iridge.jp/cosmo-oil/web-front/-/issues/46
     * @param {*} versionData
     */
    appVersionMakeRequestHeder: function (versionData) {
      versionData.appVersion = versionData.appVersion ? versionData.appVersion : '0.0.0'
      versionData.platform = versionData.platform ? versionData.platform : 'iRidge'
      versionData.osVersion = versionData.osVersion ? versionData.osVersion : '0.0'

      return versionData.appVersion + '/' + versionData.platform + '/' + versionData.osVersion
    },
    /**
     * 画面遷移時のクエリパラメータの定義チェックします.
     * パラメータの中身は空文字(''とnull)のみチェックする.
     * 1.ClsAppCVrsion,xClsOs,xClsOsVersion全て未定義の場合(旧アプリ)はfalse(正常)を返却.
     * 2.ClsAppCVrsion,xClsOs,xClsOsVersion全て定義しているが、どれか一つでも空文字ならfalse(異常)を返却.
     * 3.xClsAppCVrsion,xClsOs,xClsOsVersionどれか一つでも未定義の場合(新アプリだがクエリパラメータが欠落)はtrue(異常)を返却.
     * 4.xClsAppCVrsion,xClsOs,xClsOsVersion全て定義している場合（新アプリ）はfalse(正常)を返却.
     * ref.https://gitlab.ssl.iridge.jp/cosmo-oil/coupon-front/-/merge_requests/12#note_564935
     * ref.https://gitlab.ssl.iridge.jp/cosmo-oil/api-func/-/issues/68#note_564000
     * ref.https://iridge.slack.com/archives/GGDLUUB27/p1589526943128600?thread_ts=1589356074.419900&cid=GGDLUUB27
     * @param {*} xClsAppCVrsion
     * @param {*} xClsOs
     * @param {*} xClsOsVersion
     */
    isCLSAppVersionError: function (xClsAppCVrsion, xClsOs, xClsOsVersion) {
      // 1. Key全て未定義の場合は正常
      if (undefined === xClsAppCVrsion && undefined === xClsOs && undefined === xClsOsVersion) {
        return false
      }

      // 2. Keyは定義されているがどれか一つでもvlue値が空の場合は異常
      if (!xClsAppCVrsion || !xClsOs) {
        return true
      }

      // 3. Keyがどれか一つでも未定義の場合は異常
      if (undefined === xClsAppCVrsion || undefined === xClsOs || undefined === xClsOsVersion) {
        return true
      }

      // 4. Key全て定義済みの場合は正常
      return false
    },
    /**
     * 走行距離の表示文言の処理.
     * mileageをセット.
     * @param {*} mileage
     */
    mileageWordSet: function (mileage) {
      let mileageLabel = ''
      if (mileage < 20) {
        mileageLabel = '20,000km未満'
      } else if (mileage < 40) {
        mileageLabel = '20,000 ~ 39,999km'
      } else if (mileage < 60) {
        mileageLabel = '40,000 ~ 59,999km'
      } else if (mileage < 80) {
        mileageLabel = '60,000 ~ 79,999km'
      } else if (mileage < 100) {
        mileageLabel = '80,000 ~ 99,999km'
      } else if (mileage < 200) {
        mileageLabel = '100,000 ~ 199,999km'
      } else if (mileage > 210) {
        mileageLabel = '200,000km以上'
      }
      return mileageLabel
    },
    getMenuType: function (modelCode) {
      const SMALL_MODEL_CODE = 1
      const NORMAL_MODEL_CODE = 2
      const LIGHT_MODEL_CODE = 3
      const OTHER_MODEL_CODE = 4
      const SMALL_MENU_TYPE = 221
      const NORMAL_MENU_TYPE = 222
      const LIGHT_MENU_TYPE = 223
      const OTHER_MENU_TYPE = 224
      switch (modelCode) {
        case SMALL_MODEL_CODE:
          return SMALL_MENU_TYPE
        case NORMAL_MODEL_CODE:
          return NORMAL_MENU_TYPE
        case LIGHT_MODEL_CODE:
          return LIGHT_MENU_TYPE
        case OTHER_MODEL_CODE:
          return OTHER_MENU_TYPE
      }
    }
  }
}
